export default "__VITE_ASSET__Cf7kCfSY__"